var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{attrs:{"id":"vue-gf-platform-menu"}},[_c('WebMenu',{attrs:{"menu-model":_vm.menuModel,"profile-menu-model":_vm.profileMenuModel,"menu-slide-direction":_vm.menuSlideDirection}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }